









  import { Vue, Component } from 'vue-property-decorator'
  import uuid from 'uuid-random'
  import { Prop } from 'nuxt-property-decorator'
  import OneProductTileGallery from '~/components/organisms/product/OneProductTileGallery.vue'

  @Component({
    components: {
      OneProductTileGallery,
    },
  })
  export default class OneEuEnergyLabel extends Vue {
    @Prop({
      type: Object,
    })
    product!: any

    showEuEnergyLabel: Number | null = null
    galleryImages: any = [
      {
        href: this.energyCard,
        thumbnail: this.energyCard,
      },
    ]

    optionsGallery: any = {
      titleElement: false,
    }

    get productIdx() {
      return `${this.product.id}-${uuid()}`
    }

    get energyClass() {
      return this.product?.energyClass ?? null
    }

    get energyLabel() {
      return this.energyClass?.energyLabel
    }

    get energyCard() {
      return this.energyClass?.energyCard
    }

    changeVisibilityLabel(payload: boolean) {
      this.showEuEnergyLabel = payload ? 1 : null
    }
  }
